var _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8868 12.297C15.4343 11.322 15.75 10.1985 15.75 9C15.75 5.27175 12.7283 2.25 9 2.25C5.27175 2.25 2.25 5.27175 2.25 9C2.25 12.7283 5.27175 15.75 9 15.75C10.1985 15.75 11.322 15.4343 12.297 14.8868L15.75 15.75L14.8868 12.297Z",
    stroke: "#282828",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86706 9.24262C8.94056 9.16913 9.05906 9.16913 9.13256 9.24262C9.20606 9.31612 9.20606 9.43463 9.13256 9.50813C9.05906 9.58163 8.94056 9.58163 8.86706 9.50813C8.79431 9.43463 8.79431 9.31612 8.86706 9.24262ZM5.86706 9.24262C5.94056 9.16913 6.05906 9.16913 6.13256 9.24262C6.20606 9.31612 6.20606 9.43463 6.13256 9.50813C6.05906 9.58163 5.94056 9.58163 5.86706 9.50813C5.79431 9.43463 5.79431 9.31612 5.86706 9.24262ZM11.8671 9.24262C11.9406 9.16913 12.0591 9.16913 12.1326 9.24262C12.2061 9.31612 12.2061 9.43463 12.1326 9.50813C12.0591 9.58163 11.9406 9.58163 11.8671 9.50813C11.7943 9.43463 11.7943 9.31612 11.8671 9.24262Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 9.375,
    r: 0.75,
    fill: "#282828"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.375,
    r: 0.75,
    fill: "#282828"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9.375,
    r: 0.75,
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessages);
export default __webpack_public_path__ + "static/media/chat_messages.0ac1abca987cf59dfdee6284d6293878.svg";
export { ForwardRef as ReactComponent };